// @flow

// DataTable Module
import datatable from './datatable'

// Operator State
import { initialState as operatorState } from 'fc-operator-user'

// Constants
import {
  TABLE_BRANCH,
} from './constants'

export default {
  [TABLE_BRANCH]: datatable.initialState,
  ...operatorState,
}
